import React from 'react';

// MongoDB leaf logo - reusable SVG component
const MongoLogo = ({ size = 24, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-label="MongoDB"
    role="img"
  >
    <title>MongoDB</title>
    <path
      fill="#10AA50"
      d="M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0 1 11.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296.604-.463.85-.693a11.342 11.342 0 0 0 3.639-8.464c.01-.814-.103-1.662-.197-2.218z"
    />
    <path
      fill="#00ED64"
      d="M11.964 0c-.03.03-.058.06-.088.09.126.155.293.291.462.428.72.577 4.443 3.696 4.744 10.037.28 5.907-4.27 9.428-4.886 9.878-.024.017-.041.041-.06.059.34.157.703.229 1.087.229 0-.107.05-1.51.05-1.51l.06-.75c.283-.213.567-.428.842-.65a11.34 11.34 0 0 0 3.63-8.457c.014-.813-.096-1.662-.197-2.222C16.339 1.549 12.35.297 11.964 0z"
    />
    <path
      fill="#B8C4C2"
      d="M11.855 20.478c-.19.94-.34 1.856-.462 2.762L11.34 24c.246-.001.492-.011.735-.035-.031-.185-.055-.373-.086-.55-.196-1.052-.16-2.014-.134-2.937z"
    />
  </svg>
);

export default MongoLogo;
